import { CONFIRM_SOURCE_BY_SURFACE, type AppSurface } from '@ctcells/core'
import { createContext, useContext } from 'react'

/**
 * **표면 선언 — 셸(레이아웃)만 연다.** `ConsoleLayout` = `console` · `TabletLayout` = `tablet`.
 *
 * 🔴 **기본값은 `null`(미선언)이다.** 선언이 없는 곳에서 확약 창구를 지어내지 않는다 —
 *    `client_app` 을 기본값으로 두면 새 셸이 선언을 잊어도 조용히 「데스크톱」으로 기록된다.
 *    미선언이면 확약 버튼이 비활성 + 사유로 선다(`BatchDetailContainer`).
 * ⚠ 화면 코드는 이 값을 읽지 않는다. 컨테이너가 확약 훅에 넘기는 용도뿐이다.
 */
export const SurfaceContext = createContext<AppSurface | null>(null)

/** 이 표면의 L2 확약 창구. 미선언·모듈 패드면 `null` — 보낼 값이 없다 */
export function useConfirmSource() {
  const surface = useContext(SurfaceContext)
  return surface === null ? null : CONFIRM_SOURCE_BY_SURFACE[surface]
}
